import { ReactNode } from 'react';
import { getPaddedHitStroke } from '../../../../helpers/hitAreaScale';
import { DIMENSION_LINE_STROKE_WIDTH } from '../dimensionTokens';
import { DimensionArrow } from './DimensionArrow';
import { ExtensionLine } from './ExtensionLine';

type DimensionLineProps = {
  id: string;
  lineStart: [number, number];
  lineEnd: [number, number];
  cornerStart?: [number, number];
  cornerEnd?: [number, number];
  showExtensionLines?: boolean;
  isDragging: boolean;
  scale: number;
  children: ReactNode;
  style?: React.CSSProperties;
};

export const DimensionLine = ({
  id,
  lineStart,
  lineEnd,
  cornerStart,
  cornerEnd,
  showExtensionLines = true,
  isDragging,
  scale,
  children,
  style,
}: DimensionLineProps) => {
  // Always show extension lines when dragging to provide visual feedback
  const shouldShowExtensionLines = showExtensionLines || isDragging;

  return (
    <g
      id={id}
      className={`dimension-group${isDragging ? ' dimension-dragging' : ''}`}
      style={style}
    >
      <line
        x1={lineStart[0]}
        y1={lineStart[1]}
        x2={lineEnd[0]}
        y2={lineEnd[1]}
        strokeWidth={getPaddedHitStroke(
          DIMENSION_LINE_STROKE_WIDTH,
          1,
          2,
          scale
        )}
        visibility="hidden"
        pointerEvents="all"
        className="dimension-hit-area"
      />
      {shouldShowExtensionLines && cornerStart && (
        <ExtensionLine from={cornerStart} to={lineStart} />
      )}
      {shouldShowExtensionLines && cornerEnd && (
        <ExtensionLine from={cornerEnd} to={lineEnd} />
      )}
      {showExtensionLines && (
        <DimensionArrow
          start={lineStart}
          end={lineEnd}
          showStartMarker
          id={id}
        />
      )}
      {children}
    </g>
  );
};
